import React, { useEffect, useState } from 'react'
import { Row, Col, Container, Button, Card } from 'react-bootstrap';

import banner from '../assets/image/banner2 1.png';
import thumb from '../assets/image/d1 1.png';
import user from '../assets/image/d2 11.png';
import kart from '../assets/image/d3 11.png';

import brandone from '../assets/image/huffpost 1.png';
import brandtwo from '../assets/image/forbes 1.png';
import brandthree from '../assets/image/business 1.png';
import brandfour from '../assets/image/lifehacker 1.png';
import brandfive from '../assets/image/theguardian 1.png';
import brandsix from '../assets/image/financialtimes 1.png';

import boxone from '../assets/image/f1 1.png';
import boxtwo from '../assets/image/f2 1.png';
import boxthree from '../assets/image/f3 1.png';
import boxfour from '../assets/image/f4 1.png';
import boxfive from '../assets/image/f5 1.png';
import boxsix from '../assets/image/f6 1.png';
import resume from '../assets/image/cv 1.png';
import OBJECTS from '../assets/image/OBJECTS.png';
import { Link, useSearchParams } from 'react-router-dom';

import { getItem, setItem } from '../config/localStorage';
import FullPageLoader from '../component/loader/FullPageLoader';

function Home() {

    const [loader, setLoader] = useState(false);

    const AUTH_TOKEN = getItem("token");
    const POPPIN_JOB_BASE_URL = process.env.REACT_APP_POPPIN_JOB_BASE_URL;
    const LogInApplication = () => {
        localStorage.clear();
        window.location.href = POPPIN_JOB_BASE_URL + 'login';
    }

    /** To set the query string token on local storage start  */
    const [searchParams] = useSearchParams();
    const tokenId = searchParams.get('token');
    const getTokenP = async () => {
        try {
            setLoader(true);
            const getPoppinJobApptoken = searchParams.get('token');
            const PYTHON_BASE_URL = process.env.REACT_APP_BACKEND_PYTHON_BASE_URL;
            const getPhytokenResponse = await fetch(PYTHON_BASE_URL + 'user-authentication/', {
                method: 'POST',
                headers: {
                    'Authorization': getPoppinJobApptoken,
                    'Content-Type': 'application/json'
                }
            });
            const resultData = await getPhytokenResponse.json();
            if (resultData.accessToken) {
                setLoader(false);
                setItem('token', getPoppinJobApptoken);
                setItem('authToken', resultData.accessToken); // this token use for python api authentication
                window.location.href = '/';
            } else {
                setLoader(false);
                alert('Authentication failed. Please try agina!')
                window.location.href = POPPIN_JOB_BASE_URL + 'login';
            }
        } catch (e) {
            setLoader(false);
            alert('Authentication failed. Please try agina!')
            window.location.href = POPPIN_JOB_BASE_URL + 'login';
            // console.error('Error:', e);
        }
    }

    useEffect(() => {
        if (tokenId) {
            localStorage.clear();
            getTokenP();
        }
    }, [tokenId])

    if (loader) {
        return (
            <><FullPageLoader /></>
        );
    }
    /** To set the query string token on local storage end  */

    return (
        <>
            {/* Section One start  */}
            <Container fluid className='home-section-one py-5'>
                <Container>
                    <Row>
                        <Col className='col-md-6 col-sm-12 home-part-one'>
                            <div className='home-part-one-inner'>
                                <h4 className='heading-one'>Fast. Easy. Effective</h4>
                                <h2 className='heading-two'>Poppin Jobs. The Best</h2>
                                <h2 className='heading-three'>Online AI Resume Builder</h2>
                                <p className='text-one'>Experience Poppin' Jobs, the best AI resume builder available. Our advanced technology crafts personalized, professional resumes that stand out and impress employers, ensuring you put your best foot forward in your job search.</p>
                                {
                                    AUTH_TOKEN ?
                                        <Link to="/resume-builder"><Button className='btn button-green cv-btn'>Create your resume</Button></Link>
                                        :
                                        <Button className='btn button-green cv-btn' onClick={LogInApplication}>Create your resume</Button>
                                }
                            </div>
                        </Col>
                        <Col className='col-md-6 col-sm-12 home-part-two d-none d-md-flex'>
                            <img src={banner} alt="hero-section" className='img-fluid' />
                        </Col>
                    </Row>
                </Container>
            </Container>
            {/* Section One end  */}


            {/* Section two start  */}
            <Container fluid className='home-section-two'>
                <Container>
                    <Row>
                        <Col className='col-md-6 col-sm-12 col-lg-6 home-part-one mx-sm-auto order-2 order-lg-1 col-12'>
                            <Card>
                                <Row className='m-0'>
                                    <Col className='col-md-3 col-sm-12 card-left-part-out col-12'><img src={thumb} alt="thumb" /></Col>
                                    <Col className='col-md-9 col-sm-12 card-right-part-out col-12 text-center text-sm-start'>
                                        <div className='card-right-part-in text-sm-center text-md-start'>
                                            <h5>Easy Online Resume Builder</h5>
                                            <p>Effortlessly create your resume with our easy online AI builder. Design a professional resume in minutes.</p>
                                        </div>
                                    </Col>
                                </Row>
                            </Card>

                            <Card>
                                <Row className='m-0'>
                                    <Col className='col-md-3 col-sm-12 card-left-part-out col-12'><img src={user} alt="thumb" /></Col>
                                    <Col className='col-md-9 col-sm-12 card-right-part-out col-12 text-center text-sm-start'>
                                        <div className='card-right-part-in text-sm-center text-md-start'>
                                            <h5>Step By Step Expert Tips</h5>
                                            <p>Get step-by-step expert tips to guide you through creating a standout resume. Follow our advice for a professional and polished result.</p>
                                        </div>
                                    </Col>
                                </Row>
                            </Card>

                            <Card>
                                <Row className='m-0'>
                                    <Col className='col-md-3 col-sm-12 card-left-part-out col-12'><img src={kart} alt="thumb" /></Col>
                                    <Col className='col-md-9 col-sm-12 card-right-part-out col-12'>
                                        <div className='card-right-part-in text-sm-center text-md-start'>
                                            <h5>Recruiter Approved Phrases</h5>
                                            <p>Enhance your resume with recruiter-approved phrases. Use language that captures attention and highlights your strengths.</p>
                                        </div>
                                    </Col>
                                </Row>
                            </Card>

                        </Col>
                        <Col className='col-md-6 col-sm-12 col-lg-6 home-part-one mx-sm-auto order-1 order-lg-2 col-12'>
                            <div className='home-part-two-in color-circle-part'>
                                <ul>
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                </ul>
                                <h4>Why Choose Our Platform?</h4>
                                <p>Choose our platform for its user-friendly design, comprehensive expert tips, and recruiter-approved templates. Benefit from intuitive tools that simplify the resume-building process and ensure your resume stands out to employers. We provide everything you need to create a professional, polished resume that showcases your strengths and maximizes your chances of success.</p>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </Container>
            {/* Section two end  */}

            {/* Section three start  */}
            <Container fluid className='home-section-three d-none'>
                <Container>
                    <Row className='logo-section-outer'>
                        <div className="col-6 col-lg-2"><img src={brandone} className='w-100' /></div>
                        <div className="col-6 col-lg-2"><img src={brandtwo} className='w-100' /></div>
                        <div className="col-6 col-lg-2"><img src={brandthree} className='w-100' /></div>
                        <div className="col-6 col-lg-2"><img src={brandfour} className='w-100' /></div>
                        <div className="col-6 col-lg-2"><img src={brandfive} className='w-100' /></div>
                        <div className="col-6 col-lg-2"><img src={brandsix} className='w-100' /></div>
                    </Row>
                </Container>
            </Container>
            {/* Section three end  */}


            {/* Section four start  */}
            <Container fluid className='home-section-four'>
                <Container>
                    <Row>
                        <div className='sectio-four-outer color-circle-part'>
                            <ul>
                                <li></li>
                                <li></li>
                                <li></li>
                                <li></li>
                                <li></li>
                                <li></li>
                                <li></li>
                            </ul>
                            <h4>Our Main Features</h4>
                            <p>Our AI resume builder offers customizable templates, real-time feedback, and recruiter-approved phrases to create professional-looking resumes. Highlight key skills, integrate work experience and education, and keep your information secure with our intuitive and advanced tools.</p>
                        </div>
                    </Row>
                    <Row>

                        <Col className='col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12 mb-4'>
                            <Card className='card-section'>
                                <Card.Body>
                                    <Card.Img variant="top" src={boxone} />
                                    <Card.Title>Proven Resume Templates to increase Hiring Chance</Card.Title>
                                    <Card.Text className=' text-center'>
                                        Discover expertly crafted resume templates designed to highlight your strengths and increase your chances of landing the job. Stand out to employers with a polished, professional look.
                                    </Card.Text>
                                    {/* <Button className='read-more'>
                                        Read More <i className="fa-solid fa-arrow-right"></i>
                                    </Button> */}
                                </Card.Body>
                            </Card>
                        </Col>

                        <Col className='col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12 mb-4'>
                            <Card className='card-section'>
                                <Card.Body>
                                    <Card.Img variant="top" src={boxtwo} />
                                    <Card.Title>Creative, Modern and Clean Templates Design</Card.Title>
                                    <Card.Text className=' text-center'>
                                        Explore our collection of creative, modern, and clean templates designed to make your resume visually appealing and professional. Impress employers with a standout presentation.
                                    </Card.Text>
                                    {/* <Button className='read-more'>
                                        Read More <i className="fa-solid fa-arrow-right"></i>
                                    </Button> */}
                                </Card.Body>
                            </Card>
                        </Col>

                        <Col className='col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12 mb-4'>
                            <Card className='card-section'>
                                <Card.Body>
                                    <Card.Img variant="top" src={boxthree} />
                                    <Card.Title>Easy and Intuitive Online Resume Builder</Card.Title>
                                    <Card.Text className=' text-center'>
                                        Create your resume effortlessly with our easy and intuitive online builder. Customize your professional profile with just a few clicks and get ready to impress employers.
                                    </Card.Text>
                                    {/* <Button className='read-more'>
                                        Read More <i className="fa-solid fa-arrow-right"></i>
                                    </Button> */}
                                </Card.Body>
                            </Card>
                        </Col>

                        <Col className='col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12 mb-4'>
                            <Card className='card-section'>
                                <Card.Body>
                                    <Card.Img variant="top" src={boxfour} />
                                    <Card.Title>Free to use. Developed by hiring professionals.</Card.Title>
                                    <Card.Text className=' text-center'>
                                        Enjoy our free-to-use resume builder, developed by hiring professionals. Craft a standout resume with expert-designed tools and templates at no cost.
                                    </Card.Text>
                                    {/* <Button className='read-more'>
                                        Read More <i className="fa-solid fa-arrow-right"></i>
                                    </Button> */}
                                </Card.Body>
                            </Card>
                        </Col>

                        <Col className='col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12 mb-4'>
                            <Card className='card-section'>
                                <Card.Body>
                                    <Card.Img variant="top" src={boxfive} />
                                    <Card.Title>Recruiter Approved Phrases with Module Notification</Card.Title>
                                    <Card.Text className=' text-center'>
                                        Utilize recruiter-approved phrases to enhance your resume, complete with module notifications to guide you. Ensure your resume meets industry standards and catches the attention of hiring managers.
                                    </Card.Text>
                                    {/* <Button className='read-more'>
                                        Read More <i className="fa-solid fa-arrow-right"></i>
                                    </Button> */}
                                </Card.Body>
                            </Card>
                        </Col>

                        <Col className='col-xl-4 col-lg-6 col-md-6 col-sm-12 col-12 mb-4'>
                            <Card className='card-section'>
                                <Card.Body>
                                    <Card.Img variant="top" src={boxsix} />
                                    <Card.Title>Fast Easy Resume Formatting</Card.Title>
                                    <Card.Text className=' text-center'>
                                        Quickly format your resume with ease. Our tools make creating a professional and polished resume simple and efficient.
                                    </Card.Text>
                                    {/* <Button className='read-more'>
                                        Read More <i className="fa-solid fa-arrow-right"></i>
                                    </Button> */}
                                </Card.Body>
                            </Card>
                        </Col>

                    </Row>
                </Container>
            </Container>
            {/* Section four end  */}

            {/* Section five start  */}
            <Container fluid className='home-section-five'>
                <Container>
                    <Row>
                        <Col className='col-md-7 col-lg-7 col-sm-12  col-12'>
                            <div className='sectio-five-outer color-circle-part'>
                                <ul>
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                    <li></li>
                                </ul>
                                <h4>We Deliver The Best</h4>
                            </div>
                            <div className='list-item'>
                                {/* <CheckCircleFill color="#1da425" size={22} /> */}
                                <ul>
                                    <li> <i className="fa fa-check-circle" aria-hidden="true"></i> Proven Resume Templates to increase Hiring Chance</li>
                                    <li> <i className="fa fa-check-circle" aria-hidden="true"></i> Creative and Clean Templates Design</li>
                                    <li> <i className="fa fa-check-circle" aria-hidden="true"></i> Easy and Intuitive Online Resume Builder</li>
                                    <li> <i className="fa fa-check-circle" aria-hidden="true"></i> Free to use. Developed by hiring professionals.</li>
                                    <li> <i className="fa fa-check-circle" aria-hidden="true"></i> Fast Easy Resume Formatting</li>
                                    <li> <i className="fa fa-check-circle" aria-hidden="true"></i> Recruiter Approved Phrases.</li>
                                </ul>
                            </div>
                        </Col>
                        <Col className='col-md-5  col-12'>  <img src={resume} alt='resume' className='img-fluid' /> </Col>
                    </Row>
                </Container>
            </Container>
            {/* Section five end  */}

            {/* Section Six start  */}
            <Container fluid className='home-section-six'>
                <Container>
                    <Row>
                        <Col className='col-md-6 col-sm-12  col-12 text-center text-md-start mb-5 mb-sm-4 mb-md-0'>
                            <img src={OBJECTS} alt="object" className='img-fluid' />
                        </Col>
                        <Col className='col-md-6 col-sm-12 right-section  col-12 text-center text-md-start'>
                            <div>
                                <h4>Unlock your career potential with our powerful resume builder.</h4>
                                <p>Create a standout resume in minutes that opens doors to new opportunities.</p>
                                {
                                    AUTH_TOKEN ?
                                        <Link to="/resume-builder"><Button className='button-green btn-info'>Your dream job</Button></Link>
                                        :
                                        <Button className='button-green btn-info' onClick={LogInApplication}>Your dream job</Button>
                                }
                            </div>
                        </Col>
                    </Row>
                </Container>
            </Container>
            {/* Section Six end  */}
        </>
    )
}

export default Home
